import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./placement.css";
import placementImg from "../../assets/testingimages/otherimages/placement.jpg";

function Placement() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="placement-section">
      <div className="container">

        <section>
          <div className="headlines-for-all" data-aos="fade-up">
            <h4>
              <span>Placement </span> Support
            </h4>
          </div>
        </section>

        <div className="placement-content">

          {/* Left Content */}
          <div className="placement-text">

            <h2 className="sub-heading" data-aos="fade-up" data-aos-delay="100">
              Placement Benefits
            </h2>

            <ul>
              <li data-aos="fade-up" data-aos-delay="150">
                <strong>Strong Industry Network:</strong>{" "}
                <span className="fazo-fazo">
                  <strong>Fazo Academy</strong>
                </span>{" "}
                has partnerships with leading analytics companies, IT firms, and business
                intelligence consultancies. We regularly connect graduates to Data Analysis
                job opportunities across India.
              </li>

              <li data-aos="fade-up" data-aos-delay="200">
                <strong>Dedicated Placement Cell:</strong> Our placement team
                conducts exclusive recruitment drives, mock assessments, and coordinates interviews.
              </li>

              <li data-aos="fade-up" data-aos-delay="250">
                <strong>Resume & LinkedIn Optimization:</strong> Get personalized
                support to create a professional resume and online profile.
              </li>

              <li data-aos="fade-up" data-aos-delay="300">
                <strong>Career Webinars & HR Sessions:</strong> Attend expert-led
                sessions to understand industry hiring trends.
              </li>
            </ul>

            <h2 className="sub-heading" data-aos="fade-up" data-aos-delay="350">
              Interview Preparation Support
            </h2>

            <ul>
              <li data-aos="fade-up" data-aos-delay="400">
                <strong>Mock Interviews:</strong> Face technical + HR mock interviews
                with industry professionals.
              </li>

              <li data-aos="fade-up" data-aos-delay="450">
                <strong>Automation Practice Tasks:</strong> Hands-on training with
                Selenium, Postman, JIRA, and other tools.
              </li>

              <li data-aos="fade-up" data-aos-delay="500">
                <strong>Test Scenario Workshops:</strong> Learn real-time test case
                creation, execution, and bug reporting.
              </li>

              <li data-aos="fade-up" data-aos-delay="550">
                <strong>Continuous Mentorship:</strong> Post-placement mentor support
                to help you grow in your QA career.
              </li>
            </ul>

          </div>

          {/* Right Image */}
          <div className="placement-image">
            <img
              src={placementImg}
              alt="Software Testing Placement Support"
              data-aos="zoom-in"
              data-aos-delay="250"
            />
          </div>

        </div>
      </div>
    </section>
  );
}

export default Placement;
